const attr = "data-booking-menu-trigger";

let els = null;

const BookingMenuTriggers = () => {

	// Search for carousel elements on page
	els = document.querySelectorAll('[' + attr + ']');

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// For each trigger
	for (const el of els) {
		const menuEl = el.nextElementSibling;

		el.addEventListener('click', (e) => {
			const state     = el.getAttribute(attr);
			let newState    = null;
			let btnText     = null;
			let menuDisplay = null;

			if (state === 'closed') {
				newState    = 'open';
				btnText     = "Hide Menu";
				menuDisplay = 'block';
			} else {
				newState    = 'closed';
				btnText     = "View Menu";
				menuDisplay = 'none';
			}

			menuEl.style.display = menuDisplay;
			el.setAttribute(attr, newState);
			el.querySelector('span').innerHTML = btnText;
		})
	}
}

export default BookingMenuTriggers;